

















import {Component, Model} from 'vue-property-decorator';
import Vue from 'vue';
import Parts from '@/components/Money/Parts.vue';
import Icon from '@/components/Icon.vue';
import CATEGORY_ICON_NAMES from "@/constants/customTagList";

@Component({components: {Icon, Parts}})
export default class IconList extends Vue {
  @Model('change', {required: true, type: String}) readonly icon!: string
  iconList = CATEGORY_ICON_NAMES

  highlight(svg: string) {
    return {
      'icon-wrapper':true,
      'selected': this.icon === svg
    }
  }


};
